<template>
  <div
    class="Fuell-Dropdown"
    ref="dropdown"
    :class="dropdownClasses"
  >
    <slot
      name="button"
      :toggle="toggle"
    >
      <div
        class="Fuell-Dropdown--button clickable Fuell-Dropdown--button-dots"
        :class="sizeClass"
        @click="toggle"
      >
        <img
          class="dots"
          alt="dot-menu"
          :src="require('@/assets/img/icons/icon-dots.svg')"
        />
      </div>
    </slot>
    <div
      class="Fuell-Dropdown--container"
      :class="containerClasses"
    >
      <div class="Fuell-Dropdown--anchor"></div>
      <div
        class="Fuell-Dropdown--content"
        :class="contentClasses"
      >
        <slot name="default"></slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: Boolean,
      default: false
    },
    sizeClass: {
      type: String,
      default: ''
    },
    classes: {
      type: Object,
      default: () => { }
    },
    contentClasses: {
      type: String,
      default: ''
    },
    closeOnClickInside: {
      type: Boolean,
      default: true
    },
    containerClasses: {
      type: String,
      default: ''
    },
    parent: {
      type: HTMLDivElement
    }
  },
  data () {
    return {
      active: false,
      dotsHeight: 25,
      anchorHeight: 7

    }
  },
  computed: {
    dropdownClasses () {
      return { active: this.active, ...this.classes }
    }
  },

  methods: {
    toggle (ev) {
      if (this.active &&
        !this.closeOnClickInside &&
        this.$refs.dropdown &&
        this.$refs.dropdown.contains(ev.target)) {
        return
      }
      this.active = !this.active
      if (!this.active) {
        window.removeEventListener('click', this.toggle)
      } else {
        window.addEventListener('click', this.toggle)
      }
      if (this.position && this.active) {
        this.selectPosition()
      }
    },
    selectPosition () {
      if ((this.parent.offsetHeight - this.$refs.dropdown?.getBoundingClientRect().bottom) < (this.$refs.dropdown.querySelector('.Fuell-Dropdown--container').offsetHeight + this.dotsHeight)) {
        this.$refs.dropdown.querySelector('.Fuell-Dropdown--anchor').className = 'Fuell-Dropdown--anchor d-none'
        this.$refs.dropdown.querySelector('.Fuell-Dropdown--container').style.top = `${-this.$refs.dropdown.querySelector('.Fuell-Dropdown--container')?.offsetHeight}px`
        this.$refs.dropdown.querySelector('.Fuell-Dropdown--container').style.right = '-4px'
      } else {
        this.$refs.dropdown.querySelector('.Fuell-Dropdown--anchor').className = 'Fuell-Dropdown--anchor d-none'
        this.$refs.dropdown.querySelector('.Fuell-Dropdown--container').style.right = '-4px'
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.Fuell-Dropdown {
  position: relative;
}
.Fuell-Dropdown--container {
  right: -11px;
  top: 25px;
}
.Fuell-Dropdown--button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: 1px 6px;
  border-radius: 4px;
  &:hover {
    background-color: var(--grey-action-3-hover);
  }
  .dots {
    width: 3px;
    height: 12px;
  }
}
.Fuell-Dropdown--button-dots-small {
  display: flex;
  height: 16px;
  width: 16px;
  border-radius: 2px;
  &.active {
    & > .dots {
      filter: invert(45%) sepia(63%) saturate(5644%) hue-rotate(187deg)
        brightness(100%) contrast(104%);
    }
    &:hover {
      filter: unset;
      background-color: unset;
    }
  }
}

.visible {
  visibility: visible;
}
.not-visible {
  visibility: hidden;
}
</style>
